export default __webpack_public_path__ + "static/media/24.1ececeb0.gif";